import store from '@/store';
import current from '@/scripts/current';

export default {
    getDataModel
}

function getDataModel(missingData) {
    if (!missingData)
        return {};
    const is2Dimensional = missingData.yearVariable && missingData.locationVariable;
    const rows = getDataRows(missingData, is2Dimensional);
    const columnHeadings = getColumnHeadings(missingData, is2Dimensional);
    const displayStates = getDisplayStatesAndYears(is2Dimensional, rows, columnHeadings, missingData, current.selectionModel);
    const note = joinList(displayStates) + '. The following are the number of source records by '
        + getLabels(missingData).join(' and ') + '.';

    return {
        columnHeadings,
        rows,
        note,
        displayStates
    };
}

function getLabels(missingData) {
    if (!missingData)
        return [];
    let labels = [];
    if (missingData.locationVariable)
        labels.push('location');
    if (missingData.yearVariable)
        labels.push('year');
    return labels;
}

function getColumnHeadings(missingData, is2Dimensional) {
    const results = is2Dimensional
        ? missingData.yearVariable.categories.map(c => c.title)
            .reduce((all, c) => (all.push(c), all), ['Total'])
        : ['Count'];
    return results;
}

function getDataRows(missingData, is2Dimensional) {
    if (is2Dimensional) {
        let results = missingData.locationVariable.categories
            .map(l => toMissingDataRow(l, missingData.yearVariable.categories));
        return results;
    } else if (missingData.locationVariable) {
        //store.state.selModel.locations.names,
        return missingData.locationVariable.categories.map(l => ({
            variable: 'location',
            counts: [store.state.report.numberOfSourceRecords[0][l.code]],
            heading: l.title
        }));
    } else if (missingData.yearVariable) {
        let results = missingData.yearVariable.categories.map(y => ({
            variable: 'year',
            counts: [store.state.report.numberOfSourceRecords[y.code][0]],
            heading: y.title
        }));
        return results;
    } else
        return [];
}

function getMissingDataCounts(years, location) {
    return [store.state.report.numberOfSourceRecords[0][location.code],
    ...years.map(y =>
        store.state.report.numberOfSourceRecords[y.code][location.code])];
}

function toMissingDataRow(location, years) {
    return {
        variable: 'location',
        counts: getMissingDataCounts(years, location),
        heading: location.title
    };
}

function joinList(items) {
    if (items.length === 0)
        return '';
    if (items.length === 1)
        return items[0];
    if (items.length === 2)
        return items[0] + ' and ' + items[1];
    const results = items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
    return results;
}
function getYears(counts, columnHeadings) {
    const results = counts.map((c, ci) => c === 0 ? ci : null).filter(i => i !== null).map(i => columnHeadings[i]);
    return results;
}

function getDisplayStatesAndYears(is2Dimensional, rows, columnHeadings, missingData, selectionModel) {
    let results = [];
    if (is2Dimensional) {
        results = is2Dimensional ?
            rows.map(r => ({
                states: [r.heading],
                years: getYears(r.counts, columnHeadings)
            })).filter(s => s.years.length > 0)
            : rows.map();
    } else if (missingData.locationVariable) {
        results = [{
            states: rows.filter(r => r.counts[0] > 0).map(r => r.heading),
            years: store.state.selModel.years.values
        }];
    } else if (missingData.yearVariable) {
        results = [{
            states: store.state.selModel.locations.names,
            years: rows.filter(r => r.counts[0] === 0).map(r => r.heading)
        }];
    }
    return results.map(s => joinList(s.states) + (s.states.length > 1 ? ' are ' : ' is ') + 'missing data for ' + joinList(s.years));
}
